import { apiClient } from '../../../api/client';
import { Conversation, ConversationDetail, CreateConversationRequest } from '../../../types/chat';

/**
 * Get all conversations for the authenticated user
 */
export const getConversations = async (): Promise<Conversation[]> => {
  const response = await apiClient.chat.chatListConversationsList();
  return response.data as unknown as Conversation[];
};

/**
 * Create a new conversation
 */
export const createConversation = async (
  conversationData: CreateConversationRequest
): Promise<ConversationDetail> => {
  const response = await apiClient.chat.chatCreateConversationCreate({
    title: conversationData.title,
    conversation_language: conversationData.conversation_language,
    proficiency_level: conversationData.proficiency_level,
  });
  return response.data as unknown as ConversationDetail;
};

/**
 * Get messages for a specific conversation
 * @param conversationId - The ID of the conversation to fetch messages from
 */
export const getConversationMessages = async (conversationId: number) => {
  // Now TypeScript knows conversationId should be a number!
  const response = await apiClient.chat.chatLastMessagesRetrieve(conversationId);
  return response.data;
};
